module.exports = __webpack_public_path__ + "static/media/logo_x.5b7e12ab.svg";